import { FLAGS, useFlag } from '@iheartjane/feature-flags';
import {
  CardCarousel,
  SpecialCard,
  normalizeSpecialsDisplayName,
} from '@iheartjane/menu';
import { EventNames } from '@iheartjane/tracking';

import { PRODUCTS_PER_PAGE_CAROUSEL } from '@jane/search/util';
import { SpecialCard as OldSpecialCard } from '@jane/shared-ecomm/components';
import { useMenu, useSpecials } from '@jane/shared-ecomm/providers';
import { track } from '@jane/shared-ecomm/tracking';

import type { MenuCarouselProps } from '../../MenuComponents/MenuSponsoredCarousel/MenuSponsoredCarousel';

export const MenuSpecialsCarousel = ({
  mode = 'ideal-width',
  title,
}: MenuCarouselProps & { title?: string }) => {
  const specialsRedesignMenu = useFlag(FLAGS.c3SpecialsRedesignMenu);

  const { store, paths } = useMenu();
  const { loadingSpecialsCards, specialsCards } = useSpecials();

  const nextBreadcrumbs = [
    { title: 'Featured', url: paths.menuCategory('featured') },
  ];

  if ((!loadingSpecialsCards && specialsCards?.length === 0) || !specialsCards)
    return null;

  const rowName = normalizeSpecialsDisplayName(title);

  return (
    <CardCarousel
      buttonAriaLabel={`View all ${rowName}`}
      cardGap={24}
      cardGapMobile={16}
      cardHeight={240}
      cardHeightMobile={240}
      cardWidth={310}
      cardWidthMobile={320}
      isLoading={loadingSpecialsCards}
      mode={mode}
      name={rowName}
      buttonTo={paths.menuCategory('specials')}
      buttonOnClick={() =>
        track({
          event: EventNames.AllSpecialsTap,
          storeName: store.name,
          storeId: store.id,
        })
      }
    >
      {specialsCards
        .filter((special) => !special.hidden_from_row)
        .slice(0, PRODUCTS_PER_PAGE_CAROUSEL)
        .map((special, index) => (
          <CardCarousel.Card key={special.id + special.title}>
            {specialsRedesignMenu ? (
              <SpecialCard
                breadcrumbs={nextBreadcrumbs}
                customSpecialBadge={special?.custom_badge}
                discountAmount={special?.discount_amount}
                discountType={special?.discount_type}
                imageSrc={special?.photo?.urls?.original}
                reservationModeLabels={store?.reservation_mode_labels}
                reservationModes={special?.reservation_modes}
                specialType={special?.special_type}
                storeComplianceLanguageSettings={
                  store?.store_compliance_language_settings
                }
                title={special.title}
                to={paths.menuSpecial({
                  id: special.id,
                  title: special.title,
                })}
                onClick={() =>
                  track({
                    event: EventNames.StoreSpecialTap,
                    source: 'Specials Row',
                    specialRankOnList: index + 1,
                    storeName: store.name,
                    storeId: store.id,
                    specialId: special.id,
                    specialType: special.special_type,
                  })
                }
              />
            ) : (
              <OldSpecialCard
                breadcrumbs={nextBreadcrumbs}
                special={special}
                store={store}
                to={paths.menuSpecial({ id: special.id, title: special.title })}
                onClick={() =>
                  track({
                    event: EventNames.StoreSpecialTap,
                    source: 'Specials Row',
                    specialRankOnList: index + 1,
                    storeName: store.name,
                    storeId: store.id,
                    specialId: special.id,
                    specialType: special.special_type,
                  })
                }
              />
            )}
          </CardCarousel.Card>
        ))}
    </CardCarousel>
  );
};
